<template>
<div class="chapter">
<div class="inner_page">
<h1>The Abu Wahab Caper</h1>
<h3 class="sigil_not_in_toc"><i>A Chance Purdue Novel</i></h3>
<h3 class="sigil_not_in_toc">Ross H. Spencer</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_TitleCover.vue?a110a00a